import { render, staticRenderFns } from "./CrearComisiones.vue?vue&type=template&id=00662c7a&scoped=true"
import script from "./CrearComisiones.vue?vue&type=script&lang=js"
export * from "./CrearComisiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00662c7a",
  null
  
)

export default component.exports